import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import SnackbarContent from '@mui/material/SnackbarContent';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { createTheme, ThemeProvider }, "@mui/material/Stack": Stack, "@mui/material/AppBar": AppBar, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/Alert": Alert, "@mui/material/SnackbarContent": SnackbarContent, "@mui/material/Button": Button, "@mui/material/IconButton": IconButton, "@mui/icons-material/Menu": MenuIcon, "@mui/icons-material/Add": AddIcon, "@mui/icons-material/Close": CloseIcon } } });
export default ClientProvider;
